import { afterNextRender, Component, computed, inject, OnInit, Signal, signal, WritableSignal } from '@angular/core';
import { AuthService } from '../auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { unableOperationMessage } from '../../shared/common/utils';
import { ModalContentService } from '../../shared/modal-content/modal-content.service';
import { KlaviyoService } from '../../shared/klaviyo/klaviyo.service';
import { Observable } from 'rxjs/internal/Observable';
import { toObservable } from '@angular/core/rxjs-interop';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-ecommerce-admin',
    imports: [],
    templateUrl: './ecommerce-admin.component.html',
    styleUrl: './ecommerce-admin.component.scss'
})
export class EcommerceAdminComponent {

  #authService = inject(AuthService);
  #route = inject(ActivatedRoute);
  #router = inject(Router);
  #modalContentService = inject(ModalContentService);
  #klaviyoService = inject(KlaviyoService);

  #klaviyoLoaded$: Observable<boolean> = toObservable(this.#klaviyoService.getKlaviyoLoaded);
  token: WritableSignal<string> = signal('');

  isFinished: WritableSignal<boolean> = signal(false);
  isError: WritableSignal<boolean> = signal(false);
  isSuccess: WritableSignal<boolean> = signal(false);

  shouldValidateKlaviyo: WritableSignal<boolean> = signal(environment.apis.klaviyo.publicApiKey !== '');

  constructor() {
    afterNextRender(() => this.#handleTokenFromUrl())
  }

  #handleTokenFromUrl() {
    const token = this.#route.snapshot.paramMap.get('token');
    if (!token) {
      unableOperationMessage(this.#modalContentService);
      setTimeout(() => {
        this.#router.navigate(['/']);
      }, 1000 * 3);
      return;
    } else {
      this.token.set(token);
      if (this.shouldValidateKlaviyo())
        this.#validateKlaviyoScriptLoaded();
      else
        this.#loginAsAdmin();
    }

  }

  #validateKlaviyoScriptLoaded() {
    this.#klaviyoLoaded$.subscribe((loaded) => {
      if (loaded)
        this.#loginAsAdmin();
    });
  }

  #loginAsAdmin() {
    this.#authService.loginAsAdmin(this.token()).subscribe();
  }

}
